import React, { Component } from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';

import logo from "./../assets/logo.png";
import { Box, Button } from '@mui/material';
import { logOut, getResource, isStaff } from '../services/login';

class CustomAppBar extends Component {
    constructor(props) {
      super(props)
      this.state = {
        username: null,
        role: null,
        isStaff: false
      }
    }

    async componentDidMount() {
      let username = await getResource('username')
      let role = await getResource('role')
      let _isStaff = await isStaff()
      this.setState({
        username,
        role,
        isStaff: _isStaff,
      })
    }

    handleLoginClick() {
      let url = `${process.env.REACT_APP_LOGIN_URL}?client_id=${process.env.REACT_APP_CLIENT_ID}`
      window.location.href = url
    }

    async handleLogoutClick() {
      logOut()
    }

    handleEval() {
      let url = `${process.env.REACT_APP_EVAL_FORM}`
      window.open(url, "_blank")
    }

    handleWebservice() {
      let url = `${process.env.REACT_APP_WEB_SERVICE}`
      window.open(url, "_blank")
    }

    render() {
      let title = "Department of Water Resource: AIML"
      if(this.state.isStaff) {
        title = title + " (Staff Version)"
      }
      return (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static">
            <Toolbar>
              <Avatar alt="Logo" src={logo} sx={{width: 36, height: 36, mr:2}} />
              <Typography variant="h6" color="inherit" component="div">{title}</Typography>
              <Box display="flex" justifyContent="flex-end" sx={{ flexGrow: 1 }}>
              <Button color="inherit" onClick={this.handleWebservice} sx={{paddingRight:4}}> บริการข้อมูล </Button>
                <Button color="inherit" onClick={this.handleEval} sx={{paddingRight:4}}> ประเมินเว็บไซต์ </Button>
                {(this.state.username==='null'||this.state.username===null)
                  ? <Button color="inherit" onClick={this.handleLoginClick}>เข้าสู่ระบบ</Button>
                  : <Box>
                      <Button color="inherit" onClick={this.handleLogoutClick}>ออกจากระบบ</Button>
                    </Box>
                }
              </Box>
            </Toolbar>
          </AppBar>
        </Box>
        
      );
    }
  }
  
  export default CustomAppBar;